const STORAGE_KEY = "fz_login_remember";

export function lerLoginSalvo() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.remember) return null;
    return {
      dominio: String(data.dominio || ""),
      login: String(data.login || ""),
    };
  } catch {
    return null;
  }
}

export function salvarPreferenciaLogin({ dominio, login, remember }) {
  if (!remember) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }

  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      remember: true,
      dominio: String(dominio || "").toLowerCase().trim(),
      login: String(login || "").trim(),
    })
  );
}
